import React from 'react';

const UserGroupIcon = ({ width = 24, height = 24, fill = '#656263' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6719 13.1299C18.0419 14.0599 19.0019 15.3199 19.0019 16.9999V19.9999H22.0019C22.5519 19.9999 23.0019 19.5499 23.0019 18.9999V16.9999C23.0019 14.8199 19.4319 13.5299 16.6719 13.1299Z"
        fill={fill}
      />
      <path
        d="M9 12C11.2091 12 13 10.2091 13 8C13 5.79086 11.2091 4 9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0019 12C17.2119 12 19.0019 10.21 19.0019 8C19.0019 5.79 17.2119 4 15.0019 4C14.5319 4 14.0919 4.1 13.6719 4.24C14.5019 5.27 15.0019 6.58 15.0019 8C15.0019 9.42 14.5019 10.73 13.6719 11.76C14.0919 11.9 14.5319 12 15.0019 12Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13C6.33 13 1 14.34 1 17V19C1 19.55 1.45 20 2 20H16C16.55 20 17 19.55 17 19V17C17 14.34 11.67 13 9 13Z"
        fill={fill}
      />
    </svg>
  );
};

export default UserGroupIcon;
